import { createReducer, on } from '@ngrx/store';
import { Country } from '@shipmercury/mercury-ui';
import {
  LoadCountriesProperties,
  LoadCountriesProps,
} from './countries.actions';

export interface CountriesState {
  countryList: Country[];
}

export const initialCountriesState: CountriesState = {
  countryList: [],
};

export const countriesReducer = createReducer(
  initialCountriesState,

  on(LoadCountriesProps, (state) => {
    return {
      ...state,
    };
  }),

  on(LoadCountriesProperties, (state, { countryList }) => {
    return {
      ...state,
      countryList,
    };
  })
);
